/**
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
/**
 * Date         : 2021-03-08 18:08:36
 * description  : 描述
 * author       : zhizhan
 */
import { merge } from "..";
import UpLoadFileHuawei from "./uploadFileHuawei";

class UploadFileAws extends UpLoadFileHuawei {
  constructor(param) {
    super(param);
    const { headers, uploadType, AccessToken } = param;
    this.headers = merge(
      { ossType: this.getOssType(uploadType), "Access-Token": AccessToken },
      headers
    );
  }
}

export default UploadFileAws;



// WEBPACK FOOTER //
// ./src/yx-widget/utils/upload/uploadFileAws.js